<script setup lang="ts">
import type { OrderTotals } from "@/schemas/order";

defineProps<{ totals: OrderTotals }>();
</script>

<template>
  <table class="text-right text-lg">
    <tbody>
      <tr v-for="({ label, value }, key) in totals" :key="key" class="align-top">
        <th class="py-1 pr-4 leading-tight">
          {{ label }}
        </th>
        <td class="" v-html="value" />
      </tr>
    </tbody>
  </table>
</template>
